import { api } from "../intreceptor/apiInterceptor";

export interface CreateContractorRequest {
  name: string;
  email?: string;
  contractorSectors?: string[] | null;
  contractorUnionType?: string | null;
  mobileNumber?: string | null;
  isSignatory?: boolean | null;
  localUnions?: string[] | null;
  isMultiTrade?: boolean | null;
  contractorTrades?: {
    trade?: string | null;
    unionType?: string | null;
  }[] | null;
  status?: string | null;
  address?: {
    addressType?: string | null;
    address?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    coordinates?: number[] | null;
  }[] | null;
  additionalNotes?: string | null;
  userId?: string | null;
}

export interface Contractor {
  id: string;
  name: string;
  email: string;
  cellNumber: number;
  isSignatory: boolean;
  isMultiTrade: boolean;
  status: string;
  additionalNotes: string | null;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  contractorUnionType: string | null;
  contractorSectors?: {
    id: string;
    isActive: boolean;
    sector: {
      id: string;
      name: string;
      description?: string;
    };
  }[];
  contractorTrades?: {
    id: string;
    unionType?: string;
    localUnion?: {
      id: string;
      code: string;
      unionNumber: number;
    };
    trade?: {
      id: string;
      name: string;
    };
  }[];
  address?: {
    id?: string;
    addressType?: string;
    address?: string;
    city?: string;
    province?: string;
    postalCode?: string;
    coordinates?: number[];
  }[];
}

export interface GetContractorsParams {
  status?: string[];
  contractor?: string[];
  contractorIds?: string[];
  sector?: string[];
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  limit?: number;
  page?: number;
}

export interface PaginatedContractorResponse {
  data: Contractor[];
  totalCount: number;
  page: number;
  limit: number;
}

export const ContractorService = {
  createContractor: async (data: CreateContractorRequest) => {
    return api.fetch('/contractor/createContractor', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  
  updateContractor: async (id: string, data: CreateContractorRequest) => {
    return api.fetch(`/contractor/updateContractor/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  getContractor: async (): Promise<Contractor[]> => {
    return api.fetch('/contractor/getContractors');
  },

  getContractorWithTrades: async (): Promise<Contractor[]> => {
    return api.fetch('/contractor/getContractorsWithTrades');
  },

  getContractorById: async (id: string): Promise<Contractor> => {
    return api.fetch(`/contractor/get-contractor/${id}`, {
      method: 'GET'
    });
  },

  getContractorsWithFilters: async (params: GetContractorsParams): Promise<PaginatedContractorResponse> => {
    const queryParams = new URLSearchParams();
    if (params.status) {
      queryParams.append('status', JSON.stringify(params.status));
    }
    if (params.contractor) {
      queryParams.append('contractor', JSON.stringify(params.contractor));
    }
    if (params.contractorIds) {
      queryParams.append('contractorIds', JSON.stringify(params.contractorIds));
    }
    if (params.sector) {
      queryParams.append('sector', JSON.stringify(params.sector));
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }
    if (params.sortBy) {
      queryParams.append('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params.page) {
      queryParams.append('page', params.page.toString());
    }
    return api.fetch(`/contractor/get-contractors?${queryParams.toString()}`);
  },

  getMechanicalContractorsFromVisits: async (): Promise<Contractor[]> => {
    return api.fetch('/contractor/get-contractors-from-visits');
  },

  checkDeactivationEligibility: async (id: string): Promise<{ canDeactivate: boolean; reason?: string }> => {
    return api.fetch(`/contractor/canDeactivate/${id}`, {
      method: 'GET'
    });
  }
}